import React from 'react';
import './Work.css';
import Project from './Project';
import NetflixClone from './NetflixClone.jpg';
import CovidTracker from './CovidTracker.jpg';
import Voyage from './Voyage.jpg';
import WhatsappClone from './WhatsappClone.jpg';
// import BuildGuild from './BuildGuild.jpg';
import SpotifyClone from './SpotifyClone.jpg';
// import IAE from './IAE.jpg';
// import BlogApp from './BlogApp.jpg';
import DocKitchen from './DocKitchen.jpg';
import Patientio from './Patientio.jpg';
import Idoctify from './Idoctify.jpg';
import AmazonClone from './AmazonClone.jpg';

function Work() {
  return (
    <div className="container" id="projects">
      <div className="row">
        <div className="col-2"></div>
        <div className="col-8">
          <h1 className="text-center" style={{ marginTop: '3rem' }}>
            Projects
          </h1>
          <div className="work__border"></div>
          <p className="text-justify my-5">
            My projects are listed below. To explore them check out the links
            provided with them. The github link to open source projects is also
            provided.
          </p>
        </div>
        <div className="col-2"></div>
      </div>

      <div className="row">
        <Project
          img={DocKitchen}
          name="Doc's Kitchen"
          detail="Recipe sharing application where chefs can share their recipes with people. They create food category and add recipes to it."
          web="https://doc-kitchen.firebaseapp.com/"
          tags={[
            'mern',
            'authentication',
            'multer-image-upload',
            'react-context-api',
            'react-hooks',
            'mobile-responsive',
            'flexbox',
          ]}
        />
        <Project
          img={AmazonClone}
          name="Ecommerce App"
          detail="Ecommerce application, explore it using credentials admin@example.com with password: 123456."
          git="https://github.com/AnumMujahid/mern-ecommerce"
          web="https://amazoncloneapplication.herokuapp.com/"
          tags={[
            'mern',
            'redux',
            'paypal',
            'authentication',
            'admin-panel',
            'react-bootstrap',
            'heroku',
            'react-redux',
            'mobile-responsive',
          ]}
        />

        <Project
          img={Patientio}
          name="Patientio"
          detail="A hospital management system using django providing user authentication through allauth."
          git="https://github.com/AnumMujahid/Patientio"
          tags={[
            'python',
            'django',
            'html5',
            'jquery',
            'sqlite-database',
            'css3-animation',
            'django-allauth',
            'mobile-responsive',
          ]}
        />

        <Project
          img={WhatsappClone}
          name="Whatsapp Clone"
          detail="Whatsapp Clone developed with MERN and using pusher to make mongoDB real time."
          git="https://github.com/AnumMujahid/mern-whatsapp-clone"
          web="https://whatsapp-clone-by-anum.firebaseapp.com/"
          tags={[
            'mern',
            'pusher',
            'google-auth',
            'react-functional-components',
            'react-hooks',
            'react-context-api',
          ]}
        />
        <Project
          img={Idoctify}
          name="IDOCtify"
          detail="A web application built on Django to better manage records of patients by implementing Facial Recognition."
          git="https://github.com/AnumMujahid/iDOCtify"
          tags={[
            'python',
            'django',
            'open-cv',
            'numpy',
            'face-recognition',
            'sqlite-database',
            'mobile-responsive',
          ]}
        />
        <Project
          img={Voyage}
          name="Voyage"
          detail="Frontend developed for a travel web application to help travelers know a place better."
          git="https://github.com/AnumMujahid/Voyage_Front_End"
          web="https://voyage-92e65.web.app/"
          tags={[
            'html5',
            'css3',
            'javascript',
            'jquery',
            'bootstrap',
            'mobile-responsive',
            'frontend-dev',
            'css3-animations',
          ]}
        />

        {/* <Project
          img={IAE}
          name="IAE Web Portfolio"
          detail="Website developed for Ibnemujahid Associates and Engineers to share their projects and to easily reach their clients"
          web="https://www.ibnemujahidassociates.com/"
          tags={[
            'html5',
            'css3',
            'js',
            'jquery',
            'bootstrap4',
            'firebase',
            'mobile-responsive',
          ]}
        /> */}

        <Project
          img={CovidTracker}
          name="Covid 19 Tracker"
          detail="Covid 19 Tracker provides number of cases, recovered cases, number of deaths caused due to Covid in various regions."
          git="https://github.com/AnumMujahid/react-covid-tracker"
          web="https://covid-tracker-by-anum.web.app/"
          tags={[
            'react',
            'react-functional-components',
            'react-hooks',
            'firebase-hosting',
            'disease.sh-api',
            'flexbox',
          ]}
        />
        <Project
          img={SpotifyClone}
          name="Spotify Clone"
          detail="Spotify clone application built to using Spotify API in React. It displays the list of user's playlists and songs in them."
          git="https://github.com/AnumMujahid/react-spotify-clone"
          web="https://spotify-clone-by-anum.web.app/"
          tags={[
            'react',
            'react-functional-components',
            'react-hooks',
            'react-context-api',
            'spotify-api',
            'firebase',
            'flexbox',
          ]}
        />

        {/* <Project
          img={BuildGuild}
          name="Build Guild Web Portal"
          detail="Web portal to keep track of sales, visualiza data and to perform analytics on data, developed for Build Guild property sales"
          git="https://github.com/AnumMujahid/Prototype_webapp"
          tags={[
            'html5',
            'css3',
            'js',
            'bootstrap4',
            'jquery',
            'jinja2',
            'git-github',
            'mobile-responsive',
          ]}
        /> */}

        {/* <Project
          img={BlogApp}
          name="MERN Blog App"
          detail="Simple MERN blog application built to learn CRUD and RESTful routing"
          git="https://github.com/AnumMujahid/mern-blog-project"
          web="https://blog-anum.firebaseapp.com/"
          tags={[
            'react',
            'expressjs',
            'nodejs',
            'mongodb',
            'firebase',
            'heroku',
            'react-class-component',
            'bootstrap',
          ]}
        /> */}

        <Project
          img={NetflixClone}
          name="Netflix Clone"
          detail="Netflix Clone built using react that fetches the data from TMDB API for the content in various categories."
          git="https://github.com/AnumMujahid/netflix-clone"
          web="https://netflix-clone-79589.web.app/"
          tags={[
            'react',
            'react-functional-components',
            'react-hooks',
            'tmdb-api',
            'firebase-hosting',
            'flexbox',
          ]}
        />
      </div>
    </div>
  );
}

export default Work;
